/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ColumnHeader from "./ColumnHeader";
import EnergyValue from "./EnergyValue";
import { client } from "../../../Utils/axiosClient";
import { RENTAL_STATUS } from "../constant";

// batteries currently with the driver, end energy fetched from iot.
// display only, the api recalculates the end energy when the batteries are lent
const ExistingBatteries = ({ batteries, setBatteries }) => {
  const { currentRental } = useSelector((state) => state.rentals);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!currentRental?.id) return;

    const getBatteries = async () => {
      try {
        setLoading(true);

        const response = await client.get(
          `${process.env.REACT_APP_API_URL}/rentals/get-rental-batteries`,
          {
            params: {
              rentalId: currentRental.id,
              currentStatus: RENTAL_STATUS.ONGOING,
            },
          },
        );

        const list = response?.data?.result || [];

        setBatteries(
          list.map((item) => ({
            id: item.id,
            registrationNo: item.registrationNo,
            startEnergy: item.startEnergy,
            endEnergy: item.capacity,
          })),
        );
      } catch (error) {
        console.log(error);
        setBatteries([]);
      } finally {
        setLoading(false);
      }
    };

    getBatteries();
  }, [currentRental?.id]);

  return (
    <div className="mt-6">
      <p className="px-4 font-poppins font-medium text-xs">
        Energy levels of the batteries
      </p>

      <p className="mt-1 mb-6 px-4 font-aileron font-normal text-xs text-dark-gray">
        Energy of the batteries with the driver, used for calculating energy
        total revenue generation.
      </p>

      <ColumnHeader type="default" />

      {loading ? (
        <div className="flex items-center py-2 h-12 border-b-[0.5px] border-light-grey">
          <div className="px-6">
            <EnergyValue loading />
          </div>
        </div>
      ) : null}

      {!loading
        ? batteries?.map((item) => (
            <div
              key={item?.id}
              className="flex items-center py-2 h-12 border-b-[0.5px] border-light-grey"
            >
              <p className="flex-1 px-6 font-aileron text-xs font-semibold text-black">
                {item?.registrationNo}
              </p>

              <p className="flex-1 px-6 font-aileron text-xs font-semibold text-black capitalize">
                {currentRental?.hubName}
              </p>

              <div className="flex-1 px-6 flex items-center">
                <EnergyValue value={item?.startEnergy} />
              </div>

              <div className="flex-1 px-6 flex items-center">
                <EnergyValue value={item?.endEnergy} />
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default ExistingBatteries;
